declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Track each visited route as the Google Ads Page view conversion selected by
 * the account. This is separate from the regular Analytics page_view event.
 */
export const trackPageViewConversion = () => {
  window.gtag?.("event", "conversion", {
    send_to: "AW-811773901/fzBMCMuG74wcEM3fioMD",
    value: 1.0,
    currency: "INR",
  });
};

/**
 * Track phone link clicks as Google Ads conversions.
 */
export const trackPhoneClick = () => {
  window.gtag?.("event", "conversion", {
    send_to: "AW-811773901/WSPmCKiv8IwcEM3fioMD",
    value: 1.0,
    currency: "INR",
  });
};

/**
 * Track WhatsApp button clicks as Google Ads conversions.
 */
export const trackWhatsAppClick = () => {
  window.gtag?.("event", "conversion", {
    send_to: "AW-811773901/WSPmCKiv8IwcEM3fioMD",
    value: 1.0,
    currency: "INR",
  });
};

/**
 * Track form submissions (quote requests, contact inquiries) as Google Ads conversions.
 */
export const trackFormConversion = (email?: string) => {
  if (email) {
    window.gtag?.("set", "user_data", { email });
  }
  window.gtag?.("event", "conversion", {
    send_to: "AW-811773901/0sRTCOWtpvIbEM3fioMD",
    value: 1.0,
    currency: "INR",
  });
};

/**
 * Report a quote/enquiry submission to Analytics & Tag Manager with the city
 * and product attached, so conversions can be broken down by both.
 */
export const trackQuoteSubmit = (info: {
  product?: string | null;
  city?: string | null;
  path?: string | null;
}) => {
  const payload = {
    event_category: "lead",
    product: info.product || "not specified",
    city: info.city || "not specified",
    page_path: info.path || (typeof window !== "undefined" ? window.location.pathname : ""),
  };
  window.gtag?.("event", "generate_lead", payload);
  (window as unknown as { dataLayer?: unknown[] }).dataLayer?.push({
    event: "quote_form_submit",
    ...payload,
  });
};
